import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const machineCapabilityApi = createApi({
  reducerPath: "machineCapabilityApi",
  baseQuery: appBaseQuery,
  tagTypes: ["MachineCapability"],
  endpoints: (builder) => ({
    getMachineCapabilities: builder.query({
      query: (params = {}) => buildPagedListUrl("machine-capability/", params),
      providesTags: ["MachineCapability"],
    }),
    addMachineCapability: builder.mutation({
      query: (newMachineCapability) => ({
        url: "machine-capability/",
        method: "POST",
        body: newMachineCapability,
      }),
      invalidatesTags: ["MachineCapability"],
    }),
    updateMachineCapability: builder.mutation({
      query: ({ uid, ...updatedMachineCapability }) => ({
        url: `machine-capability/${uid}`,
        method: "PUT",
        body: updatedMachineCapability,
      }),
      invalidatesTags: ["MachineCapability"],
    }),
    deleteMachineCapability: builder.mutation({
      query: (uid) => ({
        url: `machine-capability/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["MachineCapability"],
    }),
  }),
});

export const {
  useGetMachineCapabilitiesQuery,
  useLazyGetMachineCapabilitiesQuery,
  useAddMachineCapabilityMutation,
  useUpdateMachineCapabilityMutation,
  useDeleteMachineCapabilityMutation,
} = machineCapabilityApi;
